import { useContext } from 'react';

import { AppContext } from '@r-app/app-context';
import { DrawApplianceGroupCenterDimension } from './draw-appliance-group-center-dimension';
import { ShowDimensions } from '@r-core/types';

export type DrawApplianceGroupDimensionsProps = {
	panelItemGroupId: string;
	isCountertop?: boolean;
}

export const DrawPanelItemGroupDimensions = ({ panelItemGroupId, isCountertop = false }: DrawApplianceGroupDimensionsProps): React.ReactElement => {
	const { controller: { options }} = useContext(AppContext);

	if (options.showDimensionsMode !== ShowDimensions.None) {
		return <>
			<DrawApplianceGroupCenterDimension panelItemGroupId={ panelItemGroupId } isCountertop={ isCountertop }/>
		</>;
	}

	return null;
};

